<template>
	<el-form-item v-if="element && !element.options.hidden" :label="getLabel(element)" :label-width="getLabelWidth(element)" :prop="element.name">
		<template v-if="element.type === 'input'">
			<el-input
				v-model="data"
				:style="{ width: element.options.width }"
				:maxlength="element.options.maxlength"
				:placeholder="element.options.placeholder"
				:clearable="element.options.clearable"
				:disabled="disabled || element.options.disabled"
				:readonly="element.options.readonly"
				:show-password="element.options.showPassword"
				:show-word-limit="element.options.showWordLimit"
				@change="handleChange(data, element)"
			>
			</el-input>
		</template>

		<template v-if="element.type === 'editor'">
			<ma-editor
				v-model="data"
				:upload="upload"
				:placeholder="element.options.placeholder"
				:disabled="disabled || element.options.disabled"
				:height="element.options.height"
			></ma-editor>
		</template>

		<template v-if="element.type === 'textarea'">
			<el-input
				v-model="data"
				type="textarea"
				:style="{ width: element.options.width }"
				:maxlength="element.options.maxlength"
				:rows="element.options.rows"
				:placeholder="element.options.placeholder"
				:clearable="element.options.clearable"
				:disabled="disabled || element.options.disabled"
				:readonly="element.options.readonly"
				:show-word-limit="element.options.showWordLimit"
				@change="handleChange(data, element)"
			/>
		</template>

		<template v-if="element.type === 'number'">
			<el-input-number
				v-model="data"
				:style="{ width: element.options.width }"
				:max="element.options.max"
				:min="element.options.min"
				:step="element.options.step"
				:precision="element.options.precision"
				:controls-position="element.options.controlsPosition"
				:readonly="element.options.readonly"
				:disabled="disabled || element.options.disabled"
				@change="handleChange(data, element)"
			/>
		</template>

		<template v-if="element.type === 'radio'">
			<el-radio-group v-model="data" :style="{ width: element.options.width }" :disabled="disabled || element.options.disabled">
				<template v-if="element.options.button">
					<el-radio-button v-for="item of element.options.options" :key="item.value" :value="item.value">{{ item.label }}</el-radio-button>
				</template>
				<template v-else>
					<el-radio v-for="item of element.options.options" :key="item.value" :value="item.value">{{ item.label }}</el-radio>
				</template>
			</el-radio-group>
		</template>

		<template v-if="element.type === 'checkbox'">
			<el-checkbox-group v-model="arrayData" :disabled="disabled || element.options.disabled">
				<template v-if="element.options.button">
					<el-checkbox-button v-for="item of element.options.options" :key="item.value" :value="item.value">
						{{ item.label }}
					</el-checkbox-button>
				</template>
				<template v-else>
					<el-checkbox v-for="item of element.options.options" :key="item.value" :value="item.value">{{ item.label }}</el-checkbox>
				</template>
			</el-checkbox-group>
		</template>

		<template v-if="element.type === 'select' && !element.options.multiple && element.options.optionsType == 'option'">
			<el-select
				v-model="data"
				:style="{ width: element.options.width }"
				:multiple="element.options.multiple"
				:placeholder="element.options.placeholder"
				:filterable="element.options.filterable"
				:clearable="element.options.clearable"
				:disabled="disabled || element.options.disabled"
				@change="handleChange(data, element)"
			>
				<el-option
					v-for="item of element.options.options"
					:key="item[`${element.options.props.value}`]"
					:value="item[`${element.options.props.value}`]"
					:label="item[`${element.options.props.label}`]"
				/>
			</el-select>
		</template>
		<template v-if="element.type === 'select' && element.options.multiple && element.options.optionsType == 'option'">
			<el-select
				v-model="arrayData"
				:style="{ width: element.options.width }"
				multiple
				:placeholder="element.options.placeholder"
				:filterable="element.options.filterable"
				:clearable="element.options.clearable"
				:disabled="disabled || element.options.disabled"
			>
				<el-option
					v-for="item of element.options.options"
					:key="item[`${element.options.props.value}`]"
					:value="item[`${element.options.props.value}`]"
					:label="item[`${element.options.props.label}`]"
				/>
			</el-select>
		</template>
		<template v-if="element.type === 'select' && !element.options.multiple && element.options.optionsType == 'dict'">
			<ma-dict-select
				v-model="data"
				:multiple="element.options.multiple"
				:style="{ width: element.options.width }"
				:dict-type="element.options.dictName"
				:clearable="element.options.clearable"
				:filterable="element.options.filterable"
				:disabled="element.options.disabled"
				@change="handleChange(data, element)"
			/>
		</template>
		<template v-if="element.type === 'select' && element.options.multiple && element.options.optionsType == 'dict'">
			<ma-dict-select
				v-model="arrayData"
				multiple
				:style="{ width: element.options.width }"
				:dict-type="element.options.dictName"
				:filterable="element.options.filterable"
				:disabled="element.options.disabled"
				:clearable="element.options.clearable"
				@change="handleChange(data, element)"
			/>
		</template>

		<template v-if="element.type === 'time'">
			<el-time-picker
				v-model="data"
				:format="element.options.format"
				:is-range="element.options.isRange"
				:placeholder="element.options.placeholder"
				:start-placeholder="element.options.startPlaceholder"
				:end-placeholder="element.options.endPlaceholder"
				:clearable="element.options.clearable"
				:disabled="disabled || element.options.disabled"
				:style="{ width: element.options.width }"
			/>
		</template>

		<template v-if="element.type === 'date'">
			<el-date-picker
				v-model="data"
				:format="element.options.format"
				:value-format="element.options.format"
				:type="element.options.type"
				:placeholder="element.options.placeholder"
				:start-placeholder="element.options.startPlaceholder"
				:end-placeholder="element.options.endPlaceholder"
				:clearable="element.options.clearable"
				:disabled="disabled || element.options.disabled"
				:style="{ width: element.options.width }"
				@change="handleChange(data, element)"
			/>
		</template>

		<template v-if="element.type === 'rate'">
			<el-rate
				v-model="data"
				:max="element.options.max"
				:allow-half="element.options.allowHalf"
				:clearable="element.options.clearable"
				:disabled="disabled || element.options.disabled"
				:style="{ width: element.options.width }"
			/>
		</template>

		<template v-if="element.type === 'switch'">
			<el-switch v-model="data" :disabled="disabled || element.options.disabled" />
		</template>

		<template v-if="element.type === 'slider'">
			<el-slider
				v-model="data"
				:min="element.options.min"
				:max="element.options.max"
				:step="element.options.step"
				:show-input="element.options.showInput"
				:disabled="disabled || element.options.disabled"
				:style="{ width: element.options.width }"
			/>
		</template>

		<template v-if="element.type === 'text'">
			<el-text :type="element.options.type" :size="element.options.size">{{ element.options.defaultValue }}</el-text>
		</template>

		<template v-if="element.type === 'link'">
			<el-link :type="element.options.type" :href="element.options.href" target="_blank" :underline="element.options.underline">
				{{ element.options.defaultValue }}
			</el-link>
		</template>

		<template v-if="element.type === 'file'">
			<div style="width: 100%">
				<el-upload
					v-model:file-list="fileList"
					style="width: 100%"
					:action="upload"
					:show-file-list="false"
					:multiple="element.options.multiple"
					:limit="element.options.limit"
					:on-preview="handleFilePreview"
					:on-remove="handleRemove"
					:on-success="handleSuccess"
					:disabled="disabled || element.options.limit === 0"
					:method="uploadMethod"
					:data="uploadData"
				>
					<el-button v-if="!element.options.disabled" type="primary">{{ t('componentsModule.generateForm.clickUpload') }}</el-button>
				</el-upload>

				<!-- 文件列表显示 -->
				<div v-if="data && data.length > 0" class="fileBox">
					<div class="fileGrid">
						<div v-for="item in data" :key="item.url" class="fileItem">
							<div class="fileContent" @click="handleFileView(item.url)">
								<div class="fileIcon">
									<img :src="getFileTypeSvg(item.url)" :alt="getFileType(item.url)" class="iconImage" />
								</div>
								<div class="fileInfo">
									<div class="fileName">{{ item.name }}</div>
									<div class="fileSize">{{ formatFileSize(item.size || 0) }}</div>
								</div>
							</div>
							<div class="fileActions">
								<el-button type="danger" circle size="small" icon="Delete" @click="handleFileDelete(item)"></el-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-if="element.type === 'image'">
			<div>
				<el-upload
					v-model:file-list="fileList"
					list-type="picture-card"
					:action="upload"
					:multiple="element.options.multiple"
					:limit="element.options.limit"
					:on-preview="handlePicturePreview"
					:on-remove="handleRemove"
					:on-success="handleSuccess"
					:disabled="disabled || element.options.limit === 0"
					:method="uploadMethod"
					:data="uploadData"
					:on-exceed="handleExceed"
				>
					<ma-icon icon="insert"></ma-icon>
				</el-upload>
				<div v-if="element.options.uploadTip" class="upload-tip">
					<el-text type="info" size="small">{{ element.options.uploadTip }}</el-text>
				</div>
			</div>
		</template>

		<template v-if="element.type === 'cascader'">
			<el-cascader
				v-model="arrayData"
				:options="element.options.options"
				:props="{
					multiple: element.options.multiple,
					checkStrictly: element.options.checkStrictly,
					...element.options.props
				}"
				:show-all-levels="element.options.showAllLevels"
				:style="{ width: element.options.width }"
				:placeholder="element.options.placeholder"
				:filterable="element.options.filterable"
				:clearable="element.options.clearable"
				:disabled="disabled || element.options.disabled"
			>
			</el-cascader>
		</template>

		<template v-if="element.type === 'address'">
			<ma-address
				v-model="data"
				:width="element.options.width"
				:placeholder="element.options.placeholder"
				:clearable="element.options.clearable"
				:disabled="disabled || element.options.disabled"
			>
			</ma-address>
		</template>

		<template v-if="element.type === 'treeselect' && !element.options.multiple">
			<el-tree-select
				v-model="data"
				:props="{ label: element.options.props.label, value: element.options.props.value }"
				:data="element.options.options"
				:style="{ width: element.options.width }"
				:multiple="element.options.multiple"
				:placeholder="element.options.placeholder"
				:filterable="element.options.filterable"
				:clearable="element.options.clearable"
				:disabled="disabled || element.options.disabled"
				:check-strictly="element.options.checkStrictly"
				@change="handleChange($event, element)"
			/>
		</template>
		<template v-if="element.type === 'treeselect' && element.options.multiple">
			<el-tree-select
				v-model="arrayData"
				:props="{ label: element.options.props.label, value: element.options.props.value }"
				:data="element.options.options"
				:style="{ width: element.options.width }"
				:multiple="element.options.multiple"
				:placeholder="element.options.placeholder"
				:filterable="element.options.filterable"
				:clearable="element.options.clearable"
				:disabled="disabled || element.options.disabled"
				:check-strictly="element.options.checkStrictly"
				@change="handleChange($event, element)"
			/>
		</template>

		<template v-if="element.type === 'user' && !element.options.multiple">
			<ma-user-input
				v-model="data"
				:style="{ width: element.options.width }"
				:placeholder="element.options.placeholder"
				:clearable="element.options.clearable"
				:readonly="element.options.readonly"
				:disabled="element.options.disabled"
				:multiple="element.options.multiple"
				@change="handleChange($event, element)"
			>
			</ma-user-input>
		</template>
		<template v-if="element.type === 'user' && element.options.multiple">
			<ma-user-input
				v-model="arrayData"
				:style="{ width: element.options.width }"
				:placeholder="element.options.placeholder"
				:clearable="element.options.clearable"
				:disabled="element.options.disabled"
				:multiple="element.options.multiple"
				@change="handleChange($event, element)"
			>
			</ma-user-input>
		</template>
		<template v-if="element.type === 'device' && !element.options.multiple">
			<ma-device-input
				v-model="data"
				:style="{ width: element.options.width }"
				:placeholder="element.options.placeholder"
				:clearable="element.options.clearable"
				:disabled="element.options.disabled"
				:select-data="element.options.selectData"
				@change="handleChange(data, element)"
			></ma-device-input>
		</template>
		<template v-if="element.type === 'device' && element.options.multiple">
			<ma-device-input
				v-model="arrayData"
				:style="{ width: element.options.width }"
				:placeholder="element.options.placeholder"
				:clearable="element.options.clearable"
				:disabled="element.options.disabled"
				:multiple="element.options.multiple"
				:select-data="element.options.selectData"
				@change="handleChange(arrayData, element)"
			></ma-device-input>
		</template>
		<template v-if="element.type === 'deviceBiz' && !element.options.multiple">
			<ma-inspect-device-input
				v-model="data"
				:style="{ width: element.options.width }"
				:placeholder="element.options.placeholder"
				:clearable="element.options.clearable"
				:disabled="element.options.disabled"
				@change="handleChange(data, element, $event)"
			></ma-inspect-device-input>
		</template>
		<template v-if="element.type === 'deviceBiz' && element.options.multiple">
			<ma-inspect-device-input
				v-model="arrayData"
				:style="{ width: element.options.width }"
				:placeholder="element.options.placeholder"
				:clearable="element.options.clearable"
				:disabled="element.options.disabled"
				:multiple="element.options.multiple"
			></ma-inspect-device-input>
		</template>

		<template v-if="element.type === 'orgBiz' && !element.options.multiple">
			<ma-org-inspect-select
				v-model="data"
				:style="{ width: element.options.width }"
				:placeholder="element.options.placeholder"
				:clearable="element.options.clearable"
				:disabled="element.options.disabled"
				:check-strictly="element.options.checkStrictly"
				@change="handleChange(data, element)"
			></ma-org-inspect-select>
		</template>
		<template v-if="element.type === 'orgBiz' && element.options.multiple">
			<ma-org-inspect-select
				v-model="arrayData"
				:style="{ width: element.options.width }"
				:placeholder="element.options.placeholder"
				:clearable="element.options.clearable"
				:disabled="element.options.disabled"
				:multiple="element.options.multiple"
				:check-strictly="element.options.checkStrictly"
				@change="handleChange(arrayData, element)"
			></ma-org-inspect-select>
		</template>

		<template v-if="element.type === 'dianjian' && element.options.multiple">
			<ma-dianjian-input
				v-model="arrayData"
				:style="{ width: element.options.width }"
				:placeholder="element.options.placeholder"
				:clearable="element.options.clearable"
				:disabled="element.options.disabled"
				:multiple="element.options.multiple"
			></ma-dianjian-input>
		</template>
		<template v-if="element.type === 'device_type'">
			<ma-device-type
				v-model="data"
				:props="{ label: element.options.props.label, value: element.options.props.value }"
				:style="{ width: element.options.width }"
				:placeholder="element.options.placeholder"
				:clearable="element.options.clearable"
				:disabled="element.options.disabled"
			/>
		</template>
		<template v-if="element.type === 'org'">
			<ma-org-select
				v-model="data"
				:style="{ width: element.options.width }"
				:placeholder="element.options.placeholder"
				:clearable="element.options.clearable"
				:disabled="element.options.disabled"
				:check-strictly="element.options.checkStrictly"
				@change="handleChange(data, element)"
			>
			</ma-org-select>
		</template>
		<template v-if="element.type === 'icon'">
			<SelectIcon v-model="data" />
		</template>
		<template v-if="element.type === 'post'">
			<ma-post-input
				v-model="data"
				:style="{ width: element.options.width }"
				:placeholder="element.options.placeholder"
				:clearable="element.options.clearable"
				:disabled="element.options.disabled"
			>
			</ma-post-input>
		</template>

		<template v-if="element.type === 'table'">
			<div class="table-container">
				<div class="table-header">
					<el-button type="primary" size="small" :disabled="disabled || element.options.disabled" @click="addTableRow">
						{{ t('componentsModule.generateForm.addDetail') }}
					</el-button>
				</div>
				<el-table :data="tableData" border style="width: 100%" :max-height="element.options.maxHeight || 300">
					<el-table-column
						v-for="column in element.options.columns"
						:key="column.prop"
						:prop="column.prop"
						:label="column.label"
						:width="column.width"
						:min-width="column.minWidth"
					>
						<template #default="scope">
							<template v-if="column.type === 'input'">
								<el-input
									v-model="scope.row[column.prop]"
									:placeholder="column.placeholder"
									:disabled="disabled || element.options.disabled"
									size="small"
									@change="handleTableDataChange"
								/>
							</template>
							<template v-else-if="column.type === 'number'">
								<el-input-number
									v-model="scope.row[column.prop]"
									:placeholder="column.placeholder"
									:disabled="disabled || element.options.disabled"
									:min="column.min || 0"
									:max="column.max"
									:precision="column.precision || 0"
									size="small"
									style="width: 100%"
									@change="handleTableDataChange"
								/>
							</template>
							<template v-else-if="column.type === 'select'">
								<el-select
									v-model="scope.row[column.prop]"
									:placeholder="column.placeholder"
									:disabled="disabled || element.options.disabled"
									size="small"
									style="width: 100%"
									@change="handleTableDataChange"
								>
									<el-option v-for="option in column.options" :key="option.value" :label="option.label" :value="option.value" />
								</el-select>
							</template>
							<template v-else>
								<span>{{ scope.row[column.prop] }}</span>
							</template>
						</template>
					</el-table-column>
					<el-table-column
						v-if="!disabled && !element.options.disabled"
						:label="t('componentsModule.generateForm.operation')"
						width="80"
						fixed="right"
					>
						<template #default="scope">
							<el-button type="danger" size="small" :disabled="tableData.length <= 1" @click="removeTableRow(scope.$index)">
								{{ t('componentsModule.generateForm.delete') }}
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</template>

		<template v-if="element.type === 'divider'">
			<el-divider :content-position="element.options.position">{{ element.label }}</el-divider>
		</template>
	</el-form-item>

	<el-image-viewer v-if="imgViewVisible" :url-list="[imageUrl]" @close="imgViewVisible = false" />
	<OnlinePreview v-model="fileShow" :file-url="currentFileUrl" @closed="closeView" />
</template>

<script lang="ts" setup>
import { computed, ref, watch, defineEmits } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElMessage, UploadProps } from 'element-plus'
import { UploadFile } from 'element-plus/es/components/upload/src/upload'
import { handlePreview } from '@/utils/tool'
import SelectIcon from '@/components/ma-icon-select/index.vue'
import { apiRequest } from '@/api/common'
import constant from '@/utils/constant'
import { getFileTypeSvg, getFileType, formatFileSize } from '@/utils/fileTypeIcon'

const { t } = useI18n()

const props = defineProps({
	element: {
		type: Object,
		required: true
	},
	model: {
		type: Object,
		required: true
	},
	upload: {
		type: String,
		default: ''
	},
	disabled: {
		type: Boolean,
		default: false
	},
	uploadMethod: {
		type: String,
		default: 'POST'
	},
	uploadData: {
		type: Object,
		default: null
	}
})

const fileShow = ref(false)
const currentFileUrl = ref('')

// #region debug-point D:rendered-table-options
if (props.element.name === 'customEigen') {
	fetch('http://127.0.0.1:7777/event', {
		method: 'POST',
		body: JSON.stringify({
			sessionId: 'custom-eigen-empty',
			runId: 'post-fix',
			hypothesisId: 'D',
			location: 'components/generate-form/GenerateFormItem.vue:setup',
			msg: '[DEBUG] customEigen options received by rendered form item',
			data: {
				elementType: props.element.type,
				columns: (props.element.options?.columns || []).map((item: any) => ({
					prop: item.prop,
					optionCount: Array.isArray(item.options) ? item.options.length : null,
					firstOption: item.options?.[0] || null
				}))
			},
			ts: Date.now()
		})
	}).catch(() => {})
}
// #endregion

const getLabel = (item: any) => {
	return item.options.labelHide ? '' : item.label
}

const getLabelWidth = (item: any) => {
	return item.options.labelHide ? '0' : ''
}

// 直接读写实时的 props.model，避免捕获旧引用导致父级替换 model 后 setter 失效
const data = computed({
	get: () => props.model[props.element.name],
	set: val => {
		// props.model 是父级共享的响应式容器，每次取实时引用后写入属性
		const model = props.model
		model[props.element.name] = val
	}
})

// 多选控件(如：复选框)
const arrayData = ref<any[]>([])

// 表单数据
const tableData = ref<any[]>([])

// 当多选控件值，发生变化时
watch(
	() => arrayData.value,
	newData => {
		if (!newData) {
			data.value = ''
		} else {
			// 对于cascader多选，需要保持数组结构
			if (props.element.type === 'cascader' && props.element.options?.multiple) {
				data.value = JSON.stringify(newData)
			} else {
				data.value = newData.join(',')
			}
		}
	}
)

// 当表格数据发生变化时
watch(
	() => tableData.value,
	newData => {
		if (props.element.type === 'table') {
			data.value = JSON.stringify(newData)
		}
	},
	{ deep: true }
)

// 以下是上传控件
const fileList = ref<UploadFile[]>([])

// 处理图片、文件重置问题
watch(
	// as
	() => props.model[props.element.name],
	val => {
		const type = props.element.type
		if (type === 'image' || type === 'file') {
			if (!val) {
				fileList.value = []
				data.value = []
			} else {
				fileList.value = val.map((e: any) => {
					if (type === 'image' && !e.url.includes(constant.apiUrl)) {
						e.url = constant.apiUrl + e.url
					}
					// e.url = constant.apiUrl + e.url
					return {
						...e,
						response: {
							url: e.url
						}
					} as UploadFile
				})
			}
		} else if (type === 'table') {
			if (!val) {
				// 初始化表格数据，至少有一行
				tableData.value = [createEmptyTableRow()]
			} else {
				try {
					const parsedData = typeof val === 'string' ? JSON.parse(val) : val
					tableData.value = Array.isArray(parsedData) && parsedData.length > 0 ? parsedData : [createEmptyTableRow()]
				} catch (e) {
					tableData.value = [createEmptyTableRow()]
				}
			}
		} else if (type === 'checkbox' || type === 'cascader' || props.element.options?.multiple) {
			if (!val) {
				arrayData.value = []
				data.value = ''
			} else if (Array.isArray(val)) {
				// 回填值已经是数组，直接使用，避免被清空导致多选/复选无法回显
				arrayData.value = val
			} else if (type === 'cascader' && props.element.options?.multiple) {
				try {
					arrayData.value = JSON.parse(val)
					data.value = val
				} catch (e) {
					arrayData.value = []
					data.value = ''
				}
			} else {
				arrayData.value = String(val).split(',')
				data.value = val
			}
		} else {
			data.value = val
		}
	}
)

// 初始化图片、文件数据
if (props.element.type === 'image' || props.element.type === 'file') {
	if (data.value && data.value.length > 0) {
		const urls = data.value.map((e: any) => e.url)
		fileList.value = urls.map((url: string) => {
			return {
				url: url,
				name: url.substring(url.lastIndexOf('/') + 1),
				response: {
					url: url
				}
			} as UploadFile
		})
	}
} else if (props.element.type === 'checkbox' || props.element.type === 'cascader' || props.element.options?.multiple) {
	if (data.value) {
		if (Array.isArray(data.value)) {
			arrayData.value = data.value
		} else {
			if (props.element.type === 'cascader' && props.element.options?.multiple) {
				try {
					arrayData.value = JSON.parse(data.value as string)
				} catch (e) {
					arrayData.value = []
				}
			} else {
				arrayData.value = String(data.value).split(',')
			}
		}
	}
}

const handleSuccess: UploadProps['onSuccess'] = (response, uploadFile, uploadFileList) => {
	console.log(response)
	if (Array.isArray(data.value)) {
		if (response.code == 0) {
			console.log(uploadFileList)
			ElMessage.success(t('componentsModule.generateForm.fileUploadSuccess'))
			data.value = [...data.value, response.data]
			handleChange(data.value, props.element)
		} else {
			ElMessage.error(t('componentsModule.generateForm.fileUploadTimeout'))
		}
	}
}

const handleFileView = (e: any) => {
	// 获取文件扩展名
	const fileExtension = e.split('.').pop()?.toLowerCase()

	// 判断是否为压缩包文件
	const compressedFileTypes = ['zip', 'rar', '7z', 'tar', 'gz', 'bz2', 'xz']

	if (compressedFileTypes.includes(fileExtension)) {
		// 如果是压缩包文件，直接下载
		window.open(constant.apiUrl + e, '_blank')
	} else {
		// 其他文件类型进行预览
		currentFileUrl.value = e
		fileShow.value = true
	}
}

const closeView = () => {
	fileShow.value = false
	currentFileUrl.value = ''
}

const handleRemove: UploadProps['onRemove'] = (file: any, uploadFiles) => {
	const files = uploadFiles.map((file: UploadFile) => {
		return (file.response as any).url
	})
	let { id } = file
	// data.value = ''
	apiRequest('post', 'sys/file/deleteFile?fileId=' + id).then((res: any) => {
		if (res.code == 0) {
			if (files.length === 0) {
				data.value = ''
			} else {
				// data.value = files.join(',')
			}
		}
	})
}

const handleFileDelete = (file: any) => {
	if (!file || !file.id) {
		ElMessage.error(t('componentsModule.generateForm.fileInfoIncomplete'))
		return
	}

	apiRequest('post', 'sys/file/deleteFile?fileId=' + file.id)
		.then((res: any) => {
			if (res.code == 0) {
				ElMessage.success(t('componentsModule.generateForm.fileDeleteSuccess'))
				// 从数据中移除已删除的文件
				if (Array.isArray(data.value)) {
					data.value = data.value.filter((item: any) => item.id !== file.id)
					// 如果删除后没有文件了,设置为空数组
					if (data.value.length === 0) {
						data.value = []
					}
				} else {
					data.value = []
				}
			} else {
				ElMessage.error(res.msg || t('componentsModule.generateForm.fileDeleteFailed'))
			}
		})
		.catch(() => {
			ElMessage.error(t('componentsModule.generateForm.fileDeleteRequestFailed'))
		})
}

const handleFilePreview: UploadProps['onPreview'] = uploadFile => {
	handlePreview((uploadFile.response as any).url)
}

const isImageFile = (url: string): boolean => {
	if (!url) {
		return false
	}

	const extension = url.split('.').pop()?.toLowerCase()
	const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']

	return imageExtensions.includes(extension || '')
}

const handleExceed = (files: File[], uploadFiles: any) => {
	ElMessage.info(t('componentsModule.generateForm.exceedUploadLimit'))
}
const imgViewVisible = ref(false)
const imageUrl = ref()
const handlePicturePreview: UploadProps['onPreview'] = uploadFile => {
	imgViewVisible.value = true
	imageUrl.value = uploadFile.url
}

const emit = defineEmits(['change'])

const findTreeNode = (tree: any[], value: any, valueProp: string, childrenProp: string = 'children'): any => {
	for (const node of tree) {
		if (node[valueProp] === value) {
			return node
		}
		if (node[childrenProp] && node[childrenProp].length > 0) {
			const found = findTreeNode(node[childrenProp], value, valueProp, childrenProp)
			if (found) {
				return found
			}
		}
	}
	return null
}

const handleChange = (e: any, options: any, rows?: any) => {
	console.log(e, options, rows)
	// 如果是用户选择组件且传递的是包含完整数据的对象
	if (options && options.type === 'user' && e && typeof e === 'object' && e.users) {
		emit('change', e.ids, options, e.users)
	} else if (options.type === 'treeselect') {
		const props = options.options.props || {}
		const valueProp = props.value || 'value'
		const childrenProp = props.children || 'children'

		let selectedData = null
		if (options.options.multiple) {
			if (Array.isArray(e)) {
				selectedData = e.map(val => findTreeNode(options.options.options, val, valueProp, childrenProp)).filter(item => item !== null)
			}
		} else {
			selectedData = findTreeNode(options.options.options, e, valueProp, childrenProp)
		}
		emit('change', e, options, selectedData)
	} else {
		// 其他组件保持原有逻辑
		emit('change', e, options, rows)
	}
}
const isImage = (file: any) => {
	return file.type.startsWith('image/')
}

// 表格相关方法
const createEmptyTableRow = () => {
	const row: any = {}
	if (props.element.options?.columns) {
		props.element.options.columns.forEach((column: any) => {
			row[column.prop] = column.defaultValue || ''
		})
	}
	return row
}

const addTableRow = () => {
	tableData.value.push(createEmptyTableRow())
}

const removeTableRow = (index: number) => {
	if (tableData.value.length > 1) {
		tableData.value.splice(index, 1)
	}
}

const handleTableDataChange = () => {
	// 触发数据变化，watch会自动处理
	tableData.value = [...tableData.value]
}
</script>

<style lang="scss" scoped>
.el-upload-list__item.is-success:focus:not(:hover) .el-icon--close-tip {
	display: none !important;
}

.upload-tip {
	margin-top: 8px;
	line-height: 1.4;

	.el-text {
		color: #909399;
		font-size: 12px;
	}
}

.fileBox {
	margin-top: 16px;
	width: 100%;
	overflow: hidden;

	.fileGrid {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
		gap: 12px;
		width: 100%;
		overflow: hidden;
	}

	.fileItem {
		display: flex;
		align-items: center;
		justify-content: space-between;
		border: 1px solid #e4e7ed;
		border-radius: 6px;
		background: #ece9e9;
		transition: all 0.3s ease;
		padding: 6px 10px;
		width: 100%;
		box-sizing: border-box;
		overflow: hidden;
		margin-bottom: 0;

		&:hover {
			border-color: #409eff;
			box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
		}

		.fileContent {
			display: flex;
			align-items: center;
			flex: 1;
			cursor: pointer;
			min-width: 0;
			overflow: hidden;
		}

		.fileIcon {
			display: flex;
			flex-direction: column;
			align-items: center;
			margin-right: 10px;
			min-width: 50px;
			flex-shrink: 0;
			width: 50px;

			.iconImage {
				width: 36px;
				height: 36px;
				margin-bottom: 2px;
			}

			.fileType {
				font-size: 12px;
				color: #666;
				font-weight: 500;
			}
		}

		.fileInfo {
			flex: 1;
			min-width: 0;
			width: 100%;
			overflow: hidden;

			.fileName {
				font-size: 13px;
				color: #333;
				font-weight: 500;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				line-height: 20px;
				max-width: 100%;
				margin-bottom: 2px;
			}

			.fileSize {
				font-size: 11px;
				color: #999;
				line-height: 16px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}

		.fileActions {
			display: flex;
			align-items: center;
			margin-left: 8px;
			flex-shrink: 0;
			padding-left: 2px;
		}
	}
}

/* 表格相关样式 */
.table-container {
	width: 100%;

	.table-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 12px;

		.table-title {
			font-weight: 500;
			color: #303133;
		}
	}

	.el-table {
		.el-input,
		.el-input-number,
		.el-select {
			width: 100%;
		}

		.el-input-number .el-input__inner {
			text-align: left;
		}
	}
}
</style>
